// extracted by mini-css-extract-plugin
export default {"button":"promo-button_button__uXSQ3","close":"promo-button_close__DbrF-"};